import { render, staticRenderFns } from "./scroll-to-element.vue?vue&type=template&id=15963ae8&scoped=true&"
import script from "./scroll-to-element.vue?vue&type=script&lang=js&"
export * from "./scroll-to-element.vue?vue&type=script&lang=js&"
import style0 from "./scroll-to-element.vue?vue&type=style&index=0&id=15963ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15963ae8",
  null
  
)

export default component.exports